import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';

export default function ContactForm() {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm('service_u4he08e', 'template_02710dm', form.current, {
        publicKey: 'dp6P-5H6DTaAEm6kM',
      })
      .then(
        () => {
          console.log('SUCCESS!');
          window.location.reload();
        },
        (error) => {
          console.log('FAILED...', error.text);
        },
      );
  };

  const inputClass =
    "w-full placeholder-primary text-xs p-2.5 border-solid border-b-[1.5px] border-primary bg-transparent focus:outline-none";

  return (
    <form ref={form} onSubmit={sendEmail}>
      <div className="flex flex-col gap-0">
        <input className={inputClass} required type="text" name="name" placeholder="YOUR NAME (required)" />
        <input className={inputClass} type="text" name="partner_name" placeholder="PARTNER'S NAME" />
        <input className={inputClass} required type="email" name="email" placeholder="EMAIL (required)" />
        <input className={inputClass} required type="tel" name="phone_number" placeholder="PHONE NUMBER (required)" />
        <input className={inputClass} required type="text" name="event" placeholder="EVENT (required)" />
        <input className={inputClass} required type="text" name="location" placeholder="VENUE NAME / LOCATION (required)" />
        <input className={inputClass} required type="date" name="date" placeholder="DATE (required)" />
        <input className={inputClass} required type="number" name="guest_count" placeholder="ESTIMATED GUEST COUNT (required)" />
        <input className={inputClass} type="number" name="budget" placeholder="ESTIMATED EVENT BUDGET" />
        <input className={inputClass} required type="text" name="package" placeholder="WHAT PACKAGE ARE YOU INTERESTED IN (required)" />
        <input className={inputClass} required type="text" name="hear" placeholder="HOW DID YOU HEAR ABOUT US (required)" />
        <input className={inputClass} required type="text" name="more" placeholder="TELL US MORE ABOUT YOUR EVENT" />
      </div>
      <div className="w-full flex justify-center mt-6">
        <button type="submit" className="inline-flex mx-auto bg-button py-4 px-8 rounded-full">
          <span className="uppercase text-primary text-xs">
            Submit Inquiry
          </span>
        </button>
      </div>
    </form>
  );
}